import React, { Component } from 'react';
import ReportOverlay from './components/ReportOverlay/ReportOverlay';
import Utils from './../../../../utils';
import TeamRolePerspectives from './../../constants/TeamRolePerspectives';
import ReportSections from './../../constants/ReportSections';
import IntellectualCapabilitiesAttachment from './components/Attachments/IntellectualCapabilities/IntellectualCapabilitiesAttachment';
import AbilityToChangeAttachment from './components/Attachments/AbilityToChange/AbilityToChangeAttachment';
import PersonalityAttachment from './components/Attachments/Personality/PersonalityAttachment';
import AboutReportAttachment from './components/Attachments/AboutReport/AboutReportAttachment';
import MotivesAttachment from './components/Attachments/Motives/MotivesAttachment';
import WorkingStylesAttachment from './components/Attachments/WorkingStyles/WorkingStylesAttachment';
import CompetencyProfileAttachment from './components/Attachments/CompetencyProfile/CompetencyProfileAttachment';
import InfluencingStylesAttachment from './components/Attachments/InfluencingStyles/InfluencingStylesAttachment';
import TeamRolesAttachment from './components/Attachments/TeamRoles/TeamRolesAttachment';
import PersonaFitRozet from './../PersonaFitRozet/PersonaFitRozet';
import PersonaFitRoles from './../PersonaFitRozet/constants/PersonaFitRoles';
import WorkEnvironmentAttachment from './components/Attachments/WorkEnvironment/WorkEnvironmentAttachment';
import AbilityToChangeCalculatedAttachment from './components/Attachments/AbilityToChangeCalculated/AbilityToChangeCalculatedAttachment';
import ReportHelper from './../../helpers/ReportHelper';
import style from './style/gridoverlay.scss';

export default class Index extends Component {
    constructor(props) {
        super(props);

        this.buildReportOverlay = this.buildReportOverlay.bind(this);
    }

    /**
     * Finds the highest score for the current perspective (personality or ambition) and returns it as a span element
     * @param {Object} section - object of score section
     * @param {string} perspective - perspective to search for (zijn/willen or personality/ambition)
     * @returns {Element} HTML element containing translated score name with the right styling applied
     */
    getHighestScoringLabelForTeamRolePerspective(section, perspective) {
        const i18nParticipation = this.props.i18nParticipation;
        const scoresToBeSorted = ReportHelper.extractScoresForTeamRolePerspective(section.scores, perspective, PersonaFitRoles);
        const sortedScores = Utils.numericallySortFieldInArray(scoresToBeSorted, 'value').reverse();
        const label = sortedScores[0].label;
        let roleNameLowerCased = null;


        if (i18nParticipation[`report_rozet_${label.toLowerCase()}`]) {
            roleNameLowerCased = i18nParticipation[`report_rozet_${label.toLowerCase()}`].toLowerCase();
        }
        return <span className={ style[label.toLowerCase()] }>
            { roleNameLowerCased || sortedScores[0].label || null }
        </span>;
    }

    buildReportOverlay(reportSection) {
        const { i18nParticipation, content, defaultLanguage, product, participant, classes, LoaderComponent } = this.props;

        switch (reportSection) {
            case ReportSections.INTELLECTUAL_CAPABILITY:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <IntellectualCapabilitiesAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            case ReportSections.ABILITY_TO_CHANGE:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <AbilityToChangeAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            case ReportSections.PERSONALITY:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <PersonalityAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                    languageId={ this.props.languageId }
                    defaultLanguage={ defaultLanguage }
                />;

            case ReportSections.ABOUT_REPORT:
                return <AboutReportAttachment
                    i18nParticipation={ i18nParticipation }
                />;

            case ReportSections.MOTIVES:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <MotivesAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            case ReportSections.WORKING_STYLES:
            case ReportSections.WPQ:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <WorkingStylesAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            case ReportSections.COMPETENCY_PROFILE:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <CompetencyProfileAttachment
                    i18n={ i18nParticipation }
                    i18nParticipation={ i18nParticipation }
                    participant={ participant }
                    content={ content }
                    product={ product }
                    classes={ classes }
                />;

            case ReportSections.INFLUENCING_STYLES:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <InfluencingStylesAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            case ReportSections.TEAM_ROLES_DEVELOPMENT:
            case ReportSections.TEAM_ROLES:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                const teamRolesSection = this.props.reportData.sections.teamRoles || this.props.reportData.sections.teamRolesDevelopment || null;

                if (Object.keys(content).length && teamRolesSection) {

                    // there are used for the teamRoles and teamRolesDevelopment attachment
                    const scoresPersonality =
                        ReportHelper.extractScoresForTeamRolePerspective(teamRolesSection.scores, TeamRolePerspectives.PERSONALITY, PersonaFitRoles);
                    const scoresAmbition =
                        ReportHelper.extractScoresForTeamRolePerspective(teamRolesSection.scores, TeamRolePerspectives.AMBITION, PersonaFitRoles);

                    return <TeamRolesAttachment
                        i18n={ i18nParticipation }
                        i18nParticipation={ i18nParticipation }
                        content={ content }

                        // build up the rozets here since all the helper functions are already in assessmentReport.js
                        personalityRozet={ <PersonaFitRozet
                            classes={ `${style.teamRolesPersonaFitRozetTop} ${style.teamRolesPersonaFitRozetTop__attachment}` }
                            scores={ scoresPersonality }
                            i18nParticipation={ i18nParticipation }
                            sortByClickEnabled={ false }
                        >
                            <aside className={ `${style.teamRolesAside} ${style.teamRolesAside__attachment}` }>
                                <header>{ i18nParticipation.report_personality }</header>
                                <p dangerouslySetInnerHTML={{ __html: i18nParticipation.report_rozet_aside_personality_a }} />
                            </aside>
                        </PersonaFitRozet> }
                        ambitionRozet={ <PersonaFitRozet
                            classes={ `${style.teamRolesPersonaFitRozetTop} ${style.teamRolesPersonaFitRozetTop__attachment__right}` }
                            scores={ scoresAmbition }
                            i18nParticipation={ i18nParticipation }
                            sortByClickEnabled={ false }
                        >
                            <aside className={ `${style.teamRolesAside} ${style.teamRolesAside__attachment} ${style.teamRolesAside__attachment__right}` }>
                                <header>{ i18nParticipation.report_ambition }</header>
                                <p dangerouslySetInnerHTML={{ __html: i18nParticipation.report_rozet_aside_ambition_a }} />
                            </aside>
                        </PersonaFitRozet> }
                    />;
                }
                break;

            case ReportSections.WORK_ENVIRONMENT:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <WorkEnvironmentAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                    participantLanguage={ this.props.reportData.participant.language }
                />;

            case ReportSections.ABILITY_TO_CHANGE_CALCULATED:

                if (!Object.keys(content).length) {
                    return <LoaderComponent relative />;
                }

                return <AbilityToChangeCalculatedAttachment
                    i18nParticipation={ i18nParticipation }
                    content={ content }
                />;

            default: return null;
        }

        return null;
    }

    render() {
        const { reportOverlayVisible, reportSectionHandle, content, children } = this.props;

        return (
            <ReportOverlay
                reportOverlayVisible={ reportOverlayVisible }
                classes={{ root: style.reportDetailPageStyleOverrides }}
            >
                { reportSectionHandle ? this.buildReportOverlay(reportSectionHandle, content) : null }
                { children }
            </ReportOverlay>
        );
    }
}
